// extracted by mini-css-extract-plugin
export default {"container":"confirmMoveListings_container__AWnfc","contentWrapper":"confirmMoveListings_contentWrapper__O5zLq","text":"confirmMoveListings_text__B2QjU"};